import React from "react";
import "./BrandLogo.css";
import nvidia from "../../Images/nvidia.png"
import paypal from "../../Images/paypal.png"
import intel from "../../Images/intel.png"
import Citibank from "../../Images/Citibank.png"
import google from "../../Images/google.png"
import walmart from "../../Images/walmart.png"


const BrandLogo = () => {
  return (
    <div className="troo-da-brand-logo-section" id="troo-da-brand-logo-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="brand-logo">
              <div className="row">
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={nvidia} alt="nvidia" />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={paypal} alt="paypal"/>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={intel} alt="intel" />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={Citibank} alt="Citibank"/>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={google} alt="google"/>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="img-ss">
                    <img src={walmart} alt="walmart" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandLogo;
